import { ContainerElement, UnknownParams } from '@app/form-builder/interfaces/form.interface'
import { FormGroup } from '@angular/forms'
import { Component, OnInit, Input } from '@angular/core'

@Component({
    selector: 'dynamic-container',
    templateUrl: './dynamic.component.html'
})
export class DynamicComponent implements OnInit {
    attributes: UnknownParams = {}

    @Input() form: FormGroup
    @Input() data: ContainerElement
    
    constructor() {}

    ngOnInit() {
        // Create objects containing attributes and validations
        for (var i in this.data.attributes) {
            const attribute = this.data.attributes[i]
            this.attributes[attribute.name] = attribute.value
        }
    }
}